import React from 'react'
import { Helmet } from 'react-helmet-async'

import SkeletonBox from '@/components/skeleton/SkeletonBox'
import { PDF_DIMENSIONS } from '@/lib/constants'

const PdfSkeleton: React.FC = () => (
  <main className="overflow-auto">
    <Helmet
      htmlAttributes={{ class: 'pdf-report' }}
      bodyAttributes={{ class: 'bg-white A4' }}
    />
    <div
      className="sheet mx-auto"
      css={{
        maxWidth: PDF_DIMENSIONS.A4.portraitWidth,
        '*': {
          minHeight: PDF_DIMENSIONS.A4.portraitHeight,
        },
      }}
    >
      <SkeletonBox />
    </div>
  </main>
)

export default PdfSkeleton
